import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
// Plugins
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
// Modules
import { NgxWebstorageModule } from 'ngx-webstorage';
import { SharedModule } from '@shared/shared.module';
// Interceptor
import { AuthInterceptorProviders } from '@services/auth/auth-interceptor/auth.interceptor';
// Routing
import { AppRoutingModule } from './app-routing.module';
// Components
import { AppComponent } from './app.component';

registerLocaleData(en);

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		HttpClientJsonpModule,
		BrowserAnimationsModule,
		NgxWebstorageModule.forRoot({ prefix: 'sf', separator: '-', caseSensitive: false }),
		SharedModule,
	],
	providers: [
		AuthInterceptorProviders,
		{ provide: NZ_I18N, useValue: en_US },
	],
	bootstrap: [AppComponent]
})
export class AppModule { }